import { z } from "zod";
export const ObservabilityBackboneEvidenceV1Schema = z
    .object({
    schemaVersion: z.literal("observability-backbone-evidence.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalObservabilityBackboneEvidence(recordedAt) {
    return ObservabilityBackboneEvidenceV1Schema.parse({
        schemaVersion: "observability-backbone-evidence.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=observability-backbone-evidence.js.map